export default Schema => {
  const name = Schema.name.toUpperCase();
  const base = '@@acast-resource';

  const createActionCreator = actionType => (id, data) => dispatch => {
    const baseAction = { type: actionType, id };

    if (!data) {
      dispatch(baseAction);
      return undefined;
    }

    const entity = new Schema(data);
    dispatch({ ...baseAction, data: entity });
    return entity;
  };

  const actionTypes = {
    ADD: `${base}/ADD_${name}`,
    UPDATE: `${base}/UPDATE_${name}`,
    DELETE: `${base}/DELETE_${name}`,

    // this is a helper action when loading collections of data. instead
    // of triggering REQUEST_SUCCESS hunderds of times which causes a
    // re-render every time, we can inject multiple entities at once
    INJECT_MULTIPLE: `${base}/INJECT_MULTIPLE_${name}`,
  };

  const actionCreators = {
    add: createActionCreator(actionTypes.ADD),
    update: createActionCreator(actionTypes.UPDATE),
    delete: createActionCreator(actionTypes.DELETE),
  };

  return {
    ...actionCreators,
    ...actionTypes,
  };
};
